'use client';

import React, { Fragment, useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import Header from '../../components/Header';
import Load from '../../components/Load';
import {
  TORNEIO_POR_ID,
  TorneioPorIdData,
  TorneioPorIdVars,
  ATUALIZAR_TORNEIO,
  AtualizarTorneioVars,
  Torneio,
  criarTorneio,
  TorneioInput,
  countInscritosTorneio
} from '../../services/torneioService';
import ProfileCardTournament from '../../components/admin/ProfilecardTournament';
import RegulamentoModal from '../../components/RegulamentoModal';
import { Typography, Tooltip, IconButton } from '@mui/material';
import InscribedAthletesModal from '../../components/admin/tournament/InscribedAthletesModal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { toLocalDateTimeString, formatPeriodoTorneioBR } from '../../utils/date';
import DescricaoModal from '../../components/admin/DescricaoModal';
import RegulamentoEditModal from '../../components/admin/RegulamentoEditModal';
import LocalModal, { LocalModalForm } from '../../components/admin/LocalModal';
import LocalizacaoMapaView from '../../components/local/LocalizacaoMapaView';
import { upsertLocal, LocalInput } from '../../services/localService';
import { atualizarTorneio as atualizarTorneioService } from '../../services/torneioService';
import { formatCurrency } from '../../utils/money';

import { set } from 'react-hook-form';
import { deletarCategoriaTorneio } from '../../services/categoriaTorneioService';
import { PageBreadcrumb } from '../../components/navigation';

const EditTournament: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { data, loading, error, client, refetch } = useQuery<
    TorneioPorIdData,
    TorneioPorIdVars
  >(
    TORNEIO_POR_ID,
    {
      variables: { id: id || '' },
      skip: !id,
    },
  );

  const [torneio, setTorneio] = useState<Torneio | null>(null);
  const [countInscritos, setCountInscritos] = useState<number>(0);
  const [patrocinadores, setPatrocinadores] = useState<any[]>([]);
  const [form, setForm] = useState<{
    nome: string;
    username: string;
    subtitulo: string;
    descricao: string;
    regulamento: string;
    bannerUrl: string;
    avatarUrl: string;
    dataInicio: string;
    dataFim: string;
    dataInscricaoInicio: Dayjs | null;
    dataInscricaoFim: Dayjs | null;
    validarElegibilidade: boolean;
  }>({
    nome: '',
    username: '',
    subtitulo: '',
    descricao: '',
    regulamento: '',
    bannerUrl: '',
    avatarUrl: '',
    dataInicio: '',
    dataFim: '',
    dataInscricaoInicio: null,
    dataInscricaoFim: null,
    validarElegibilidade: false,
  });

  const [success, setSuccess] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [regulamentoOpen, setRegulamentoOpen] = useState<boolean>(false);
  const [editModeSubtitle, setEditModeSubtitle] = useState<boolean>(false);
  const [isDescricaoModalOpen, setDescricaoModalOpen] = useState<boolean>(false);
  const [regulamentoEditOpen, setRegulamentoEditOpen] = useState<boolean>(false);
  const [isLocalModalOpen, setLocalModalOpen] = useState<boolean>(false);
  const [loadingLocal, setLoadingLocal] = useState<boolean>(false);
  const [savingLocal, setSavingLocal] = useState<boolean>(false);
  const [enderecoEditOpen, setEnderecoEditOpen] = useState<boolean>(false);
  const [regulamentoCategoriaOpen, setRegulamentoCategoriaOpen] = useState<boolean>(false);
  const [regulamentoCategoriaHtml, setRegulamentoCategoriaHtml] = useState<string>('');
  const [openInscribedModal, setOpenInscribedModal] = useState<boolean>(false);

  const regulamentoHtml = form.regulamento;

  useEffect(() => {
    const state = location.state as { refreshCategories?: boolean } | undefined;
    if (!state?.refreshCategories) {
      return;
    }

    const currentState = state;

    const run = async () => {
      try {
        await refetch();
      } catch {
        // ignore refetch errors triggered on navigation back from categoria edit
      } finally {
        const { refreshCategories: _ignored, ...rest } = currentState;
        navigate(location.pathname, { replace: true, state: rest });
      }
    };

    void run();
  }, [location.state, location.pathname, navigate, refetch]);

  useEffect(() => {
    if (data?.torneioPorId) {
      const t = data.torneioPorId;
      setTorneio(t);
      setForm({
        nome: t.nome || '',
        username: t.username || '',
        subtitulo: t.subtitulo || '',
        descricao: t.descricao || '',
        regulamento: t.regulamento || '',
        bannerUrl: t.bannerUrl || '',
        avatarUrl: t.avatarUrl || '',
        dataInicio: t.dataInicio ? t.dataInicio.slice(0, 10) : '',
        dataFim: t.dataFim ? t.dataFim.slice(0, 10) : '',
        dataInscricaoInicio: t.dataInscricaoInicio ? dayjs(t.dataInscricaoInicio) : null,
        dataInscricaoFim: t.dataInscricaoFim ? dayjs(t.dataInscricaoFim) : null,
        validarElegibilidade: t.validarElegibilidade ?? false,
      });
      setPatrocinadores(t.patrocinadores || []);
    }
    if (data?.torneioPorId?.id) {
      countInscritosTorneio(data.torneioPorId.id)
        .then((count) => setCountInscritos(count))
        .catch(() => setCountInscritos(0));
    }
  }, [data]);

  // useEffect(() => {
  //   if (!id) return;
  //   refetchPatrocinadores({ torneioId: id });
  // }, [id, refetchPatrocinadores]);

  // useEffect(() => {
  //   if (patrocinadoresData?.patrocinadoresPorTorneio) {
  //     setPatrocinadores(patrocinadoresData.patrocinadoresPorTorneio);
  //   } else {
  //     setPatrocinadores([]);
  //   }
  // }, [patrocinadoresData]);

  const handleTournamentAvatarUpdated = (newUrl: string) => {
    setTorneio((prev) => (prev ? { ...prev, avatarUrl: newUrl } : prev));
    setForm((prev) => ({ ...prev, avatarUrl: newUrl }));
    if (torneio?.id) {
      client.cache.modify({
        id: client.cache.identify({ __typename: 'Torneio', id: torneio.id }),
        fields: {
          avatarUrl: () => newUrl,
        },
      });
    }
  };

  const handleDescricaoSave = (html: string) => {
    setForm((prev) => ({ ...prev, descricao: html }));
    setTorneio((prev) => (prev ? { ...prev, descricao: html } : prev));
  };

  const handleRegulamentoSave = (html: string) => {
    setForm((prev) => ({ ...prev, regulamento: html }));
    setTorneio((prev) => (prev ? { ...prev, regulamento: html } : prev));
  };

  const handleLocalSave = async (data: LocalModalForm) => {
    if (!torneio) return;
    try {
      setSavingLocal(true);
      const localInput: LocalInput = {
        nome: data.nome,
        descricao: data.descricao,
        urlLocalizacao: data.urlLocalizacao,
        endereco: {
          cep: data.cep,
          logradouro: data.logradouro,
          numero: data.numero,
          bairro: data.bairro,
          complemento: data.complemento,
          cidadeId: data.cidadeId,
        },
      };
      const local = await upsertLocal({
        id: torneio.local?.id,
        local: localInput,
      });
      if (!torneio.local?.id) {
        await atualizarTorneioService({
          id: torneio.id,
          localId: local.id,
        } as any).catch((e) => {
          setErrorMsg('Não foi possível associar o local ao torneio. Avise o suporte.');
        });
      }
      await refetch();
      alert('Local salvo com sucesso!');
      setLocalModalOpen(false);
    } catch (e) {
      // erros tratados nos services
    } finally {
      setSavingLocal(false);
    }
  };

  const handlePatrocinadoresEdit = (open: boolean) => {
    navigate(`/admin/edittournament/${id}/sponsors`, { state: { open } });
  };

  const handleOrganizacaoEdit = (open: boolean) => {
    navigate(`/admin/organizers?torneioId=${id}`, { state: { open } });
  };

  const handleEditPartidas = (categoriaId: string) => {
    navigate(`/admin/matchescategorytournament/${categoriaId}`);
  };

  const handleSalvarTorneio = async (torneioProfile: any) => {
      // Convert TorneioProfile to CriarTorneioInput
      setSuccess('');
      setErrorMsg('');
      if (!validate()) return;
      const torneioInput: TorneioInput = {
        nome: torneioProfile.nome || '',
        username: torneioProfile.username || '',

        ativo: torneio?.ativo ?? true,

        dataFim: form.dataFim || '',
        dataInicio: form.dataInicio || '',
        dataInscricaoFim:
          toLocalDateTimeString(form.dataInscricaoFim) || '',
        dataInscricaoInicio:
          toLocalDateTimeString(form.dataInscricaoInicio) || '',
        descricao: form.descricao || '',
        subtitulo: form.subtitulo || '',
        regulamento: form.regulamento || '',
        validarElegibilidade: form.validarElegibilidade,
      };

      if (!torneio?.id) {
        try {
          await criarTorneio(torneioInput);
          return
        } catch (e) {
          setErrorMsg('Não foi possível criar o torneio. Tente novamente.')
        }
      } else {
        await atualizarTorneio({
          variables: {
            id: torneio.id,
            ...torneioInput,
            username: torneioInput.username ?? '',
          },
        }).then(() => {
          setSuccess('Torneio atualizado com sucesso!');
          alert('Alterações salvas com sucesso.');
          const torneioAtualizado = {
            ...torneio,
            ...torneioInput,
            descricao: torneioInput.descricao ?? '', 
            subtitulo: torneioInput.subtitulo ?? '',
            username: torneioInput.username ?? '',
            regulamento: torneioInput.regulamento ?? '',
            ativo: torneioInput.ativo ?? true,
          };
          setTorneio(torneioAtualizado);
        }).catch(() => {
          setErrorMsg('Não foi possível salvar as alterações. Tente novamente.');
        });
      }
    }

  const [atualizarTorneio, { loading: saving }] = useMutation<
    any,
    AtualizarTorneioVars
  >(ATUALIZAR_TORNEIO, {
    onCompleted: () => {
      setSuccess('Torneio atualizado com sucesso!');
    },
    onError: () => {
      setErrorMsg('Erro ao atualizar torneio.');
    },
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value } as any));
  };

  const isValidUrl = (url: string) => {
    if (!url) return true;
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const validate = () => {
    if (!form.nome.trim()) {
      setErrorMsg('Nome é obrigatório.');
      return false;
    }
    if (!form.username.trim()) {
      setErrorMsg('Username é obrigatório.');
      return false;
    }
    if (!isValidUrl(form.bannerUrl) || !isValidUrl(form.avatarUrl)) {
      setErrorMsg('URLs inválidas.');
      return false;
    }
    if (
      !form.dataInicio ||
      !form.dataFim ||
      !form.dataInscricaoInicio ||
      !form.dataInscricaoFim
    ) {
      setErrorMsg('Datas são obrigatórias.');
      return false;
    }
    if (new Date(form.dataFim) < new Date(form.dataInicio)) {
      setErrorMsg('Data fim deve ser após data início.');
      return false;
    }
    if (
      form.dataInscricaoFim &&
      form.dataInscricaoInicio &&
      form.dataInscricaoFim.isBefore(form.dataInscricaoInicio)
    ) {
      setErrorMsg('Data fim de inscrição deve ser após início.');
      return false;
    }
    setErrorMsg('');
    return true;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!id) return;
    if (!validate()) return;
    atualizarTorneio({
      variables: {
        id,
        ...form,
        dataInscricaoInicio:
          toLocalDateTimeString(form.dataInscricaoInicio) || '',
        dataInscricaoFim:
          toLocalDateTimeString(form.dataInscricaoFim) || '',
      },
    });
  };

  const handleEditCategoria = (categoryId?: string) => {
    const state = { torneioId: torneio?.id, torneioNome: torneio?.nome };
    if (categoryId) {
      navigate(`/admin/editcategorytournament/${categoryId}`, { state });
    } else {
      navigate('/admin/editcategorytournament', { state });
    }
  };

  const handleDeleteCategoria = async (categoryId: string) => {
    if (!torneio?.id) {
      return;
    }

    const confirmed = window.confirm('Tem certeza que deseja excluir esta categoria?');
    if (!confirmed) {
      return;
    }

    try {
      const removed = await deletarCategoriaTorneio(categoryId);

      if (!removed) {
        setSuccess('');
        setErrorMsg('Nao foi possivel excluir a categoria. Tente novamente.');
        alert('Nao foi possivel excluir a categoria. Tente novamente.');
        return;
      }

      setSuccess('Categoria excluida com sucesso!');
      setErrorMsg('');
      alert('Categoria excluida com sucesso!');

      setTorneio((prev) => {
        if (!prev) {
          return prev;
        }

        const categoriasAtualizadas =
          prev.categoriasTorneio?.filter((categoria) => categoria.id !== categoryId) ?? [];

        return {
          ...prev,
          categoriasTorneio: categoriasAtualizadas,
        };
      });

      try {
        await refetch();
      } catch (refetchError) {
        console.error('Erro ao atualizar categorias do torneio apos exclusao.', refetchError);
      }
    } catch (error) {
      console.error(`Erro ao excluir categoria ${categoryId}:`, error);
      setSuccess('');
      setErrorMsg('Erro ao excluir categoria. Tente novamente.');
      alert('Erro ao excluir categoria. Tente novamente.');
    }
  };
  const localInitial = torneio?.local
    ? {
        nome: torneio.local.nome || '',
        descricao: torneio.local?.descricao || '',
        urlLocalizacao: torneio.local.urlLocalizacao || undefined,
        cep: torneio.local.endereco?.cep || '',
        logradouro: torneio.local.endereco?.logradouro || '',
        numero: torneio.local.endereco?.numero || '',
        bairro: torneio.local.endereco?.bairro || '',
        complemento: torneio.local.endereco?.complemento || '',
        uf: torneio.local.endereco?.cidade?.uf || '',
        cidadeId: torneio.local.endereco?.cidade?.id || '',
      }
    : undefined;

  const categoriaItem =  ((cat: any, index: number) => {
    let statusInscricoes = 'abertas';
    const dataHoje = new Date();
    if (cat.dataInicioInscricoes && cat.dataFimInscricoes) {
      if (dataHoje < new Date(cat.dataInicioInscricoes)) {
        statusInscricoes = 'não iniciadas';
      } else if (dataHoje > new Date(cat.dataFimInscricoes)) {
        statusInscricoes = 'encerradas';
      } else {
        statusInscricoes = 'abertas';
      }
    }

    return(
    <div
      className='d-flex row align-items-center py-2'
      style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#FFEFF4' }}
      key={cat.id}
    >
      <div className="col-6">
        <div className="form-check-label  font-xxs" >
          <strong>{cat.nome}</strong>
        </div>
        <div>
          Inscrições {statusInscricoes}
        </div>
      </div>
      <div className="col-6 justify-itens-space-around">
        <div className='row'>
          {/* <div className='col-3'>
            <i className="bi bi-file-earmark-text text-black me-2 cursor-pointer" onClick={() => {
              setRegulamentoCategoriaHtml(cat.regulamentoHtml || '');
              setRegulamentoCategoriaOpen(true);
            }}></i>
          </div> */}
          <div className='col-3'>
            <i className="bi bi-diagram-2 text-blue me-2 cursor-pointer" onClick={() => handleEditPartidas(cat.id)}></i>
          </div>
          <div className='col-3'>
            <i className="bi bi-pencil text-yellow me-2 cursor-pointer" onClick={() => handleEditCategoria(cat.id)}></i>
          </div>
          <div className='col-3'>
            <i className="bi bi-trash text-primary me-2 cursor-pointer" onClick={() => handleDeleteCategoria(cat.id)}></i>
          </div>
        </div>
      </div>
    </div>
  )});

  return (
    <Fragment>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
        <Header />


        <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left pe-0">
            <div className="row">
              <div className="col-xl-12 col-xxl-12 col-lg-12">
                {loading && <Load />}
                {error && (
                  <div className="alert alert-danger" role="alert">
                    Erro ao carregar torneio.
                  </div>
                )}
                {torneio && (
                  <>
                    <div className="mb-3">
                      <PageBreadcrumb
                        items={[
                          { label: 'Torneios', href: '/admin/tournaments' },
                          { label: torneio.nome ?? 'Torneio' },
                        ]}
                        onBack={() => navigate('/admin/tournaments')}
                        variant="bootstrap"
                      />
                    </div>
                    <ProfileCardTournament
                      torneio={torneio}
                      onAvatarUpdated={handleTournamentAvatarUpdated}
                      onSaveTorneio={handleSalvarTorneio}
                    />
                  </>
                )}
                {errorMsg && (
                  <div className="alert alert-danger mx-3 mt-3" role="alert">
                    {errorMsg}
                  </div>
                )}
                {success && (
                  <div className="alert alert-success mx-3 mt-3" role="alert">
                    {success}
                  </div>
                )}
              </div>
            </div>

            <div className="row w-100" id='edit-tournament-date'>
              <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3 mt-3 overflow-visible mx-3">
                <div className="card-body">
                  <div className="d-flex flex-column flex-md-row gap-3">
                    <div className="flex-fill">
                      <label className="d-block mb-2" htmlFor="date-inicio-picker">
                        Data de Início
                      </label>
                      <DatePicker
                        id="date-inicio-picker"
                        selected={form.dataInicio ? new Date(form.dataInicio) : null}
                        onChange={(date: Date | null) =>
                          setForm((prev) => ({
                            ...prev,
                            dataInicio: date ? date.toISOString().split('T')[0] : '',
                          }))
                        }
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                      />
                    </div>
                    <div className="flex-fill">
                      <label className="d-block mb-2" htmlFor="date-fim-picker">
                        Data de Fim
                      </label>
                      <DatePicker
                        id="date-fim-picker"
                        selected={form.dataFim ? new Date(form.dataFim) : null}
                        onChange={(date: Date | null) =>
                          setForm((prev) => ({
                            ...prev,
                            dataFim: date ? date.toISOString().split('T')[0] : '',
                          }))
                        }
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                        minDate={form.dataInicio ? new Date(form.dataInicio) : undefined}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row w-100" id='edit-tournament-inscription-date'>
              <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3 mt-3 overflow-visible mx-3">
                <div className="card-body">
                  <div className="d-flex flex-column flex-md-row gap-3">
                    <div className="flex-fill">
                      <label className="d-block mb-2" htmlFor="date-inscricao-inicio-picker">
                        Data de Início da Inscrição
                      </label>
                      <DateTimePicker
                        ampm={false}
                        value={form.dataInscricaoInicio}
                        onChange={(newValue: Dayjs | null) =>
                          setForm((prev) => ({
                            ...prev,
                            dataInscricaoInicio: newValue,
                          }))
                        }
                        format="DD/MM/YYYY HH:mm"
                        slotProps={{ textField: { id: 'date-inscricao-inicio-picker', fullWidth: true } }}
                      />
                    </div>
                    <div className="flex-fill">
                      <label className="d-block mb-2" htmlFor="date-inscricao-fim-picker">
                        Data de Fim da Inscrição
                      </label>
                      <DateTimePicker
                        ampm={false}
                        value={form.dataInscricaoFim}
                        onChange={(newValue: Dayjs | null) =>
                          setForm((prev) => ({
                            ...prev,
                            dataInscricaoFim: newValue,
                          }))
                        }
                        format="DD/MM/YYYY HH:mm"
                        slotProps={{ textField: { id: 'date-inscricao-fim-picker', fullWidth: true } }}
                        minDateTime={
                          form.dataInscricaoInicio ?? undefined
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row w-100" id="edit-tournament-elegibilidade">
              <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3 mt-3 overflow-visible mx-3">
                <div className="card-body">
                  <div className="d-flex align-items-center gap-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="validarElegibilidade"
                        checked={form.validarElegibilidade}
                        onChange={(e) =>
                          setForm((prev) => ({ ...prev, validarElegibilidade: e.target.checked }))
                        }
                      />
                      <label className="form-check-label" htmlFor="validarElegibilidade">
                        Validar elegibilidade na inscrição
                      </label>
                    </div>
                    <Tooltip
                      title="Quando ativada, a inscrição valida automaticamente gênero e idade do atleta contra as regras da categoria."
                      arrow
                    >
                      <IconButton size="small" aria-label="Informações sobre elegibilidade" tabIndex={0}>
                        <i className="bi bi-info-circle" style={{ fontSize: '1rem' }} />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>

            <div className="row w-100">
              <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3 mt-3 overflow-hidden mx-3">
                <div className="row">

                  <div className="col-xl-12 col-xxl-12 col-lg-12 card-body">
                    <div className="row">
                      <div className="col-xl-1">
                        <figure className="avatar w50 me-auto">
                          <img
                            src={torneio?.avatarUrl || "/assets/images/user.png"}
                            alt={torneio?.nome || "avatar"}
                            className="p-1 bg-white rounded-xl w-100"
                          />
                        </figure>
                      </div>
                      <div className="col-xl-6">
                        <h5 id='subtitle-tournament' className="font-xs ls-1 fw-700 text-grey-900">
                          {editModeSubtitle ? (
                            <div className="d-flex align-items-center">
                              <input
                                type="text"
                                value={form.subtitulo}
                                onChange={handleChange}
                                className="form-control me-2"
                                name="subtitulo"
                                placeholder="Subtítulo do torneio"
                                onBlur={() => setEditModeSubtitle(false)}
                                onKeyDown={e => {
                                  if (e.key === 'Enter') setEditModeSubtitle(false)
                                  if (e.key === 'Escape') setEditModeSubtitle(false)
                                }}
                                autoFocus
                              />
                            </div>
                            
                          ) : (
                            <Typography variant="subtitle1" className="text-grey-900">
                              {form?.subtitulo ? 
                              form.subtitulo : 
                              <span className='text-grey-500'>Sem subtítulo</span>}
                              <button
                                type="button"
                                className="btn btn-link p-0 ms-2"
                                style={{ lineHeight: 1 }}
                                aria-label="Editar subtitulo"
                                onClick={() => {
                                  setEditModeSubtitle(true)
                                }}
                              >
                                <i className="bi bi-pencil fs-6"></i>
                              </button>
                            </Typography>
                          )}

                          <span id='date-tournament' className="d-block font-xssss fw-500 mt-1 lh-3 text-grey-500">
                            {formatPeriodoTorneioBR(torneio?.dataInicio, torneio?.dataFim)}{" "}
                            {torneio?.local?.endereco?.cidade && (
                              <span id='city-uf-tournament' className="text-primary">
                                {torneio.local.endereco.cidade.nome},{torneio.local.endereco.cidade.uf}
                              </span>
                            )}
                          </span>
                        </h5>
                      </div>
                      <div
                        className="col-xl-5 d-flex justify-content-end align-items-end"
                        id='number-athletes-inscribed'
                        data-testid="inscribed-athletes-open"
                        role="button"
                        style={{ cursor: 'pointer' }}
                        aria-label="Ver atletas inscritos"
                        onClick={() => setOpenInscribedModal(true)}
                      >
                        {countInscritos > 0 ? (
                          <div className="">
                            <Typography variant="body2" className="text-black me-3" fontSize={'2rem'} fontWeight={700} textAlign={'right'}>
                                <span>{countInscritos}</span>
                            </Typography>
                            <Typography variant="body2" className="text-grey-500" fontSize={'1.5rem'} fontWeight={500}>
                                Atletas inscritos
                            </Typography>
                          </div>
                            ) : (
                              <span className='text-grey-500'>Nenhum inscrito</span>
                        )}
                      </div>
                      <hr />
                    </div>
                  </div>
                  <div className="col-xl-6 col-xxl-6 col-lg-6 card-body">
                    <h4 className="font-xs ls-1 fw-700 text-grey-900 mb-3">
                      Informações do torneio
                      <button
                        id='editar-descricao-torneio'
                        type="button"
                        className="btn btn-link p-0 ms-2"
                        style={{ lineHeight: 1 }}
                        aria-label="Editar descrição do torneio"
                        onClick={() => setDescricaoModalOpen(true)}
                      >
                        <i className="bi bi-pencil fs-6"></i>
                      </button>
                    </h4>
                    <hr />
                    {torneio?.descricao && (
                      <div
                        dangerouslySetInnerHTML={{ __html: torneio.descricao }}
                      />
                    )}
                    <div id='patrocinadores-torneio' className="mt-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <h4 className="font-xs ls-1 fw-700 text-grey-900 mb-3">
                          Patrocinadores do torneio
                          <button
                            id='editar-patrocinadores-torneio'
                            type="button"
                            className="btn btn-link p-0 ms-2"
                            style={{ lineHeight: 1 }}
                            aria-label="Editar patrocinadores do torneio"
                            onClick={() => handlePatrocinadoresEdit(true)}
                          >
                            <i className="bi bi-pencil fs-6"></i>
                          </button>
                        </h4>
                      </div>
                      <hr />
                      {patrocinadores.length > 0 ? (
                        <div className="d-flex flex-column gap-3">
                          {patrocinadores.map((p) => (
                            <div
                              key={p.id}
                              className="card p-3 d-flex flex-row gap-3 align-items-start"
                            >
                              <img
                                src={p.fotoUrl || '/assets/images/avatar.jpg'}
                                alt={`Foto do patrocinador ${p.nome || ''}`}
                                className="rounded"
                                style={{ width: 80, height: 80, objectFit: 'cover' }}
                              />
                              <div>
                                <h5 className="fw-600 mb-1">{p.nome}</h5>
                                <p className="mb-0">{p.descricao}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p>Nenhum patrocinador cadastrado para este torneio</p>
                      )}
                    </div>
                    <div className="d-flex justify-content-start mt-4">
                      <button
                        id="regulamento-button"
                        type="button"
                        className="btn btn-light d-flex align-items-center px-4 py-2 shadow-sm mr-auto"
                        style={{
                          backgroundColor: "#bbbbbb",
                          color: "#333",
                          border: "1px solid #000",
                          borderRadius: "8px",
                        }}
                        onClick={() => setRegulamentoOpen(true)}
                      >
                        <i
                          className="bi bi-file-earmark-text me-2"
                          style={{ fontSize: "1.2rem" }}
                        ></i>
                        <span className="fw-600">REGULAMENTO</span>
                      </button>
                      <button
                        id='editar-regulamento-torneio'
                        type="button"
                        className="btn btn-link p-0 ms-2"
                        style={{ lineHeight: 1 }}
                        aria-label="Editar regulamento do torneio"
                        onClick={() => setRegulamentoEditOpen(true)}
                      >
                        <i className="bi bi-pencil fs-6"></i>
                      </button>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mt-4">
                      <h4 className="font-xs ls-1 fw-700 text-grey-900 mb-3">
                        Endereço
                        <button
                          id="editar-endereco-torneio"
                          type="button"
                          className="btn btn-link p-0 ms-2"
                          style={{ lineHeight: 1 }}
                          aria-label="Editar endereço do torneio"
                          onClick={() => setLocalModalOpen(true)}
                        >
                          <i className="bi bi-pencil fs-6"></i>
                        </button>
                      </h4>
                    </div>
                    <hr />
                    <p className=" font-xssss fw-500 mt-1 lh-3">
                      <i className="bi bi-geo-alt-fill text-primary me-2" />
                      <strong>Local:</strong> {torneio?.local?.nome}
                      <br />
                      {torneio?.local?.endereco && (
                        <span>
                          {torneio.local?.endereco?.logradouro}, {torneio.local?.endereco?.numero}
                          {torneio.local?.endereco?.complemento ? ` ${torneio.local?.endereco?.complemento}` : ''} - {torneio.local?.endereco?.bairro}, {torneio.local?.endereco?.cidade?.nome}-{torneio.local?.endereco?.cidade?.uf} {torneio.local?.endereco?.cep}
                        </span>
                      )}
                    </p>
                    <LocalizacaoMapaView urlLocalizacao={torneio?.local?.urlLocalizacao} />
                    <h4 className="font-xs ls-1 fw-700 text-grey-900 mb-3" id='edit-tournament-discount'>
                      Desconto por categoria
                      <button
                        id="editar-desconto-torneio"
                        type="button"
                        className="btn btn-link p-0 ms-2"
                        style={{ lineHeight: 1 }}
                        aria-label="Editar desconto do torneio"
                        onClick={() =>
                          torneio?.id &&
                          (window.location.href = `/admin/discounts?torneioId=${torneio.id}`)
                        }
                      >
                        <i className="bi bi-pencil fs-6"></i>
                      </button>
                    </h4>
                    <hr />

                    {torneio?.descontoCategorias &&
                    torneio.descontoCategorias.length > 0 ? (
                      <ul className="font-xssss fw-500 mt-1 lh-3 list-unstyled">
                        {torneio.descontoCategorias.map((d) => (
                          <li key={d.id} className="mb-1">
                            <strong>{d.ordem}ª Categoria:</strong>{' '}
                            {d.tipo === 'PERCENTUAL'
                              ? `${d.valor}%`
                              : `${formatCurrency(d.valor)}`}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="font-xssss fw-500 mt-1 lh-3">
                        Nenhum desconto cadastrado.
                      </p>
                    )}

                  </div>
                  <div className="col-xl-6 col-xxl-6 col-lg-6 card-body" id='edit-tournament-organization'>
                    <h4 className="font-xs ls-1 fw-700 text-grey-900 mb-3">
                      Organização do Torneio
                      <button
                        id='editar-organizacao-torneio'
                        type="button"
                        className="btn btn-link p-0 ms-2"
                        style={{ lineHeight: 1 }}
                        aria-label="Editar organização do torneio"
                        onClick={() => handleOrganizacaoEdit(true)}
                      >
                        <i className="bi bi-pencil fs-6"></i>
                      </button>
                    </h4>
                    <hr />
                    {torneio?.organizadores && torneio.organizadores.length > 0 ? (
                      <div className="mt-3 d-flex flex-column gap-2">
                        {torneio.organizadores.map((org) => (
                          <div key={org.id} className="d-flex align-items-center mb-2" style={{ flexWrap: 'nowrap' }}>
                            {org.fotoUrl && (
                              <img
                                src={org.fotoUrl}
                                alt={org.nome}
                                className="rounded-circle me-2"
                                style={{ width: 40, height: 40, objectFit: 'cover', flexShrink: 0 }}
                              />
                            )}
                            <div className="fw-600 text-truncate" style={{ minWidth: 0, flexGrow: 1, whiteSpace: 'normal' }}>
                              {org.nome}
                            </div>
                            {org.telefone && (
                              <span className="fw-600 ms-3" style={{ whiteSpace: 'nowrap' }}>{org.telefone}</span>
                            )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="font-xssss fw-500 mt-1 lh-3">
                        Nenhum organizador cadastrado.
                      </p>
                    )}

                    
                    <h4 className="font-xxxs ls-1 fw-700 text-grey-700 mb-3 mt-4">
                      Categorias
                      <button
                        id='nova-categoria'
                        className="btn  p-0 ms-2"
                        style={{ lineHeight: 1 }}
                        aria-label="Nova categoria"
                        onClick={() => handleEditCategoria()}
                      >
                        <i className="bi bi-plus fs-6"></i>
                        Nova categoria
                      </button>
                    </h4>
                    <hr />
                    <ul className="mt-1 lh-3 list-unstyled">
                      {torneio?.categoriasTorneio?.map((cat, index) => {
                        return (categoriaItem(cat, index));
                      })}
                    </ul>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>

      <RegulamentoModal
        open={regulamentoOpen}
        onClose={() => setRegulamentoOpen(false)}
        regulamentoHtml={regulamentoHtml}
      />

      <RegulamentoModal
        open={regulamentoCategoriaOpen}
        onClose={() => setRegulamentoCategoriaOpen(false)}
        regulamentoHtml={regulamentoCategoriaHtml}
      />
      
      <RegulamentoEditModal
        open={regulamentoEditOpen}
        initialValue={form.regulamento}
        onClose={() => setRegulamentoEditOpen(false)}
        onSave={handleRegulamentoSave}
      />

      <DescricaoModal
        open={isDescricaoModalOpen}
        initialValue={form.descricao}
        onClose={() => setDescricaoModalOpen(false)}
        onSave={handleDescricaoSave}
      />
      <LocalModal 
        open={isLocalModalOpen} 
        saving={savingLocal} 
        initialValues={localInitial} 
        onClose={() => setLocalModalOpen(false)} 
        onSave={handleLocalSave} 
      /> 
      <InscribedAthletesModal
        open={openInscribedModal}
        onClose={() => setOpenInscribedModal(false)}
        tournamentId={id || torneio?.id || ''}
      />
      </LocalizationProvider> 

    </Fragment>
  );
};

export default EditTournament;








